import {
  isNodeEmpty,
  Placeholder,
  TITLE_DEFINITIONS,
} from '@xing-com/content-editor-plugin-helpers';

import { TITLE_TAG_NAME } from './constants';

const Title = ({ className, TITLE_TAG = TITLE_TAG_NAME, ...attributes }) => {
  const RenderLeaf = ({
    children,
    element,
    attributes: elementAttributes,
  } = {}) => {
    if (element.type === TITLE_DEFINITIONS.type) {
      const { placeholder, ...restOfAttributes } = attributes;
      if (placeholder && isNodeEmpty(element)) {
        return (
          <TITLE_TAG
            {...restOfAttributes}
            {...elementAttributes}
            data-editor-plugin={TITLE_DEFINITIONS.type}
            className={className}
          >
            {Placeholder(children, className, placeholder)}
          </TITLE_TAG>
        );
      } else {
        return (
          <TITLE_TAG
            {...restOfAttributes}
            {...elementAttributes}
            data-editor-plugin={TITLE_DEFINITIONS.type}
            className={className}
          >
            {children}
          </TITLE_TAG>
        );
      }
    }
  };
  return RenderLeaf;
};

export { Title };
